import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import LocationGenerationProgress from '~/javascript/components/admin/location_generation/LocationGenerationProgress.vue'

export default class extends Controller {
  static values = {
    websiteId: String,
    generateUrl: String,
    csrf: String,
    locationCount: Number,
    serviceLocationCount: Number
  }

  connect() {
    this.vueApp = createApp(LocationGenerationProgress, {
      websiteId: this.websiteIdValue,
      generateUrl: this.generateUrlValue,
      csrfToken: this.csrfValue,
      locationCount: this.locationCountValue || 0,
      serviceLocationCount: this.serviceLocationCountValue || 0
    })

    this.vueApp.mount(this.element)
  }

  disconnect() {
    if (this.vueApp) {
      this.vueApp.unmount()
      this.vueApp = null
    }
  }
}
